import React from "react";
import { Feedback } from "~/components/feedback";
import { useLingui } from "@lingui/react/macro";
import { msg } from "@lingui/core/macro";

export default function NotFound404() {
  const { t } = useLingui();
  return (
    <Feedback
      code={404}
      title={t(msg`Not found`)}
      subtitle={t(msg`This page doesn't exist.`)}
    />
  );
}
